import { FileSearchOutlined } from "@ant-design/icons";
import { IconButton, Tooltip } from "@mui/material";
import ScrollX from "components/ScrollX";
import ReactTable from "components/statosfera/table/ReactTable";
import useAuth from "hooks/useAuth";
import PaginationData from "model/dto/PaginationData";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ClientDetailsViewModel from "../model/ClientDetailsViewModel";
import ClientSessionLogList from "./sessions/ClientSessionLogList";

export default({clientId}) => {
    const dispatcher = useDispatch();
    const context = useAuth();
    const [t, i18n] = useTranslation();

    const data = useSelector(state => ClientDetailsViewModel.loadFromStore(state));
    const model = new ClientDetailsViewModel(null, context.user);
    const [loaded, setLoaded] = useState(false);
    const [filter, setFilter] = useState(model.getFieldFilter(10, "createdAt"));
    const [openDetails, setOpenDetails] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const showDetails = (item) => {
      setSelectedItem(item);
      setOpenDetails(true);
    }
    const hideDetails = () => {
        setOpenDetails(false);
    }
    useEffect(() => {
        if(data) {
          setLoaded(false);
          model.fetchClientSessions(dispatcher, clientId, filter).unwrap().then(res => {
            setLoaded(true);
          });
        }
      }, [data, dispatcher, clientId, filter]);
    if(!data) {
        return "";
    }
    const columns = useMemo(
      () => [
        {
          Header: '#',
          accessor: 'id',
          disableSortBy: true
        },
        {
          Header: t('session_id'),
          accessor: 'sessionId',
          disableSortBy: true
        },
        {
          Header: t('started'),
          accessor: 'started',
          disableSortBy: true
        },
        {
          Header: t('finished'),
          accessor: 'finished',
          disableSortBy: true
        },
        {
          Header: t('created'),
          accessor: 'createdAt'
        },
        {
          Header: t('actions'),
          accessor: 'actions'
        }
      ]);
    const handlePageChange = (data) => {
      filter.page = data;
      setFilter(PaginationData.from(filter));
    }

    const handlePageSizeChange = (data) => {
      filter.limit = data;
      setFilter(PaginationData.from(filter));
    }
  
    const handleSort = (id, desc) => {
      let sameDir = (filter.order == "desc" && desc) || (filter.order == "asc" && !desc);
      if(filter.orderBy == id && sameDir) {
        return;
      }
      filter.orderBy = id;
      filter.order = (desc) ? "desc" : "asc";
      setFilter(PaginationData.from(filter));
    }

    const sessionsData = useSelector(state => state.client.clientSessions);
    if(!sessionsData) {
      return "";
    }
    let items = [];
    sessionsData?.data?.items.forEach(i => {
      items.push({
        id: i.id,
        sessionId: i.sessionId,
        started: model.formatShortDate(i.started),
        finished: model.formatShortDate(i.finished),
        createdAt: model.formatShortDate(i.created),
        actions: <IconButton color="secondary" onClick={() => {showDetails(i)}}><Tooltip title={t('show_logs')}><FileSearchOutlined /></Tooltip></IconButton>
      });
    });
    const sortBy = { id: 'createdAt', desc: true };
    return(
      <>
        <ScrollX>
          <ReactTable
            columns={columns}
            data={items}
            page={filter.page}
            pageSize={filter.limit}
            sortBy={sortBy}
            search={''}
            rowCountTotal={sessionsData?.data?.numOfItems} 
            getHeaderProps={(column) => column.getSortByToggleProps()}
            handlePageChange={handlePageChange} 
            handlePageSizeChange={handlePageSizeChange}
            handleSort={handleSort}
            handleSearch={null}
            topSpacing={0} />
        </ScrollX>
        <ClientSessionLogList model={model} clientId={clientId} open={openDetails} onClose={hideDetails} item={selectedItem} />
      </>
    );
}